import React from 'react'
export const GHRFooter = () => {
	return (
		<>
			<footer className="bg-dark">
				<div className="container-xxl">
					<div className="row">
						<div className="col-lg-2 mb-4 mb-5">
							<a className="logo-container d-block" href="https://www.ghrhealthcare.com/">
								<img src="/assets/ghr/scripts/logo-white.svg" alt="GHR logo" className="img-fluid" />
							</a>
						</div>
						<div className="col-lg-3 col-6 mb-5">
							<ul className="footer-nav">
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities">Job Seekers</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/nursing">Nursing</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/allied-health">Allied Health</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/advanced-practice">Advanced Practice</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/physicians-staffing">Physicians</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/revcycle">Revenue Cycle Management (RCM)</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/healthcare-it">Healthcare IT</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/healthcare-leadership">Healthcare Leadership</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/what-to-expect">What to Expect</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/pay-benefits">Pay &amp; Benefits</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/your-profile">Your Profile</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/download-app">Download App</a>
								</li>

								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/index">Job Opportunities</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/job-opportunities/quick-apply">Quick Apply</a>
								</li>
							</ul>
						</div>
						<div className="col-lg-3 col-6 mb-5">
							<ul className="footer-nav">
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions">Employers</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/nurse-staffing">Nursing</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/allied-health-staffing">Allied Health</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/advanced-practice-staffing">Advanced Practice</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/physicians-staffing">Physicians</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/revenue-cycle-staffing">Revenue Cycle</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/healthcare-it-staffing">Healthcare IT</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/index">Staffing Solutions</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/managed-service-provider">Managed Service Provider</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/direct-hire">Direct Hire</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/consulting-services">Consulting Services</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/staffing-solutions/vendor-network">Affiliate Vendor Network</a>
								</li>
							</ul>
						</div>
						<div className="col-lg-2 col-12 mb-5">
							<ul className="footer-nav">
								<li>
									<a href="https://www.ghrhealthcare.com/about-us">About Us</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/about-us/index">About Us</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/about-us/our-approach">Our Approach</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/about-us/corporate-careers">Corporate Careers</a>
								</li>
								<li>
									<a href="https://www.ghrhealthcare.com/blog">Stories &amp; Resources</a>
								</li>
							</ul>
						</div>
						<div className="col-lg-2 col-12">
							<p className="fw-medium">Connect with us</p>
							<div className="footer-social">
								<a href="https://www.facebook.com/GHRhealthcarestaffing" target="_blank">
									<span className="icon-facebook"></span>
								</a>
								<a href="https://www.instagram.com/ghr_healthcare/" target="_blank">
									<span className="icon-instagram"></span>
								</a>
								<a href="https://www.linkedin.com/company/ghr-healthcare" target="_blank">
									<span className="icon-linkedin"></span>
								</a>
								<a href="https://www.youtube.com/@ghrhealthcare" target="_blank">
									<span className="icon-play"></span>
								</a>
							</div>
							<p className="fw-medium mt-3">Download the GHR Live! Job App</p>
							<p className="footer-apps">
								<a className="d-block mb-3" href="https://apps.apple.com/us/app/ghr-live/id6476303843" target="_blank">
									<img src="/assets/ghr/scripts/apple-badge.svg" alt="Apple Badge" />
								</a>
								<a href="https://play.google.com/store/apps/details?id=com.ghrhealthcare&amp;pcampaignid=web_share" target="_blank">
									<img src="/assets/ghr/scripts/google-badge.svg" alt="Google Badge" />
								</a>
							</p>
							<div className="d-flex">
								<div className="seal-img">
									<img src="/assets/ghr/scripts/goldseal_national.png" className="img-fluid" alt="Goldseal National" />
								</div>
								<div className="seal-info">
									GHR is Joint Commission Certified under the Healthcare Staffing Services Certification (HCSS). To report a concern, please click
									<a style={{ paddingLeft: '5px' }} href="https://www.jointcommission.org/contact-us/" target="_blank">
										here
									</a>
									.
								</div>
							</div>
						</div>
					</div>
					<div className="row pt-4">
						<div className="col-12">
							<p className="copyright">
								© 2025 GHR Healthcare |<a href="https://www.ghrhealthcare.com/privacy-policy">Privacy Policy</a>|{' '}
								<a href="https://www.ghrhealthcare.com/credits">Credits</a>
							</p>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}
